import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import './main.style.css';
import Api from './../../util/Api';

export default class CartModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  getProductName = (item) => {
    let itemName = (item.make_name) ? item.make_name + ' - ' : '';
    itemName += (item.model_name) ? item.model_name : '';
    return itemName;
  }

  getImageUrl = (item) => {
    let imgUrl = `${Api.IMAGE_URL}/${item.file_url}`;
    if (item.sizes && item.sizes.small) {
      imgUrl = item.sizes.small;
    }
    return imgUrl;
  }

  getCoverImageUrl = (item) => {
    let imgUrl = `${Api.IMAGE_URL}/${item.cover_file_url}`;
    if (item.cover_file_sizes && item.cover_file_sizes.small) {
      imgUrl = item.cover_file_sizes.small;
    }
    return imgUrl;
  }

  render() {
    const { items } = this.props;
    return (
      <div className="CartDropdown open-cart">
        {
          (items && items.length !== 0) ? (
            <ul className="cartListing">
              {
                items.slice(0, 3).map(item => (
                  <li>
                    <div class="min-cover-img-parent">
                      <img
                        class="image"
                        src={item && item.cover_file_url ? this.getCoverImageUrl(item) : this.getImageUrl(item)}
                      />
                      {/* <img
                        class="image min-cover-img-case"
                        src={item.item_file_url && item.item_file_url.large}
                      /> */}
                    </div>
                    <div className="content">
                      <h6>{this.getProductName(item)}</h6>
                      <span>Rs {item.amount}</span>
                    </div>
                  </li>
                ))
              }
            </ul>
          ) : (
              <div className="cartListing">
                No items in cart
            </div>
            )
        }
        {
          (items && items.length !== 0) && (
            <div className="bottom-btn">
              <Button
                variant="raised"
                size="small"
                className="button customBtn"
                type="submit"
                onClick={() => {
                  window.location.href = '/dashboards/cart';
                  // this.props.history.push('/dashboards/cart');
                }}
              // onClick={this.handleClose}
              > View Cart
              </Button>
            </div>
          )
        }
      </div>
    );
  }
}

CartModal.propTypes = {
  items: PropTypes.object // eslint-disable-line
};

CartModal.defaultProps = {
  items: []
};



// WEBPACK FOOTER //
// ./src/components/CartModal/index.js